import { render, staticRenderFns } from "./RegionsSection.vue?vue&type=template&id=02d28408&scoped=true"
import script from "./RegionsSection.vue?vue&type=script&lang=js"
export * from "./RegionsSection.vue?vue&type=script&lang=js"
import style0 from "./RegionsSection.vue?vue&type=style&index=0&id=02d28408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d28408",
  null
  
)

export default component.exports